
import { defineComponent, onMounted, ref, computed } from "vue";
import * as XLSX from "xlsx";
import moment from "moment";
import { useRoute } from "vue-router";

import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";

import ImportCsvModalsContainer from "./realestate/ImportCsvModalsContainer.vue";

export default defineComponent({
  name: "real-estate",
  components: { ImportCsvModalsContainer },
  setup() {
    const route = useRoute();
    const realEstate = ref({});

    const searchParam = ref({
      search: "",
      id: "",
      FullSiteAddress: "",
      SiteAddressHouseNumber: "",
      SiteAddressStreetPrefix: "",
      SiteAddressState: "",
      SiteAddressCity: "",
      SiteAddressStreetName: "",
      SiteAddressZip: "",
      SiteCarrierRoute: "",
      Owner1FirstName: "",
      Owner1LastName: "",
      Owner1MiddleName: "",
      Owner1SpouseFirstName: "",
      Owner2FirstName: "",
      Owner2MiddleName: "",
      Owner2LastName: "",
      Owner2SpouseFirstName: "",
      MailAdressStreetNumber: "",
      MailAddressStreetPrefix: "",
      MailAddressStreetName: "",
      MailAddressUnitNumber: "",
      MailAddressCity: "",
      MailAddressState: "",
      MailAddressZip: "",
      UseCodeDescription: "",
      OwnerOccupied: "",
      UseCodeCounty: "",
      MailCarrierRoute: "",
      Zoning: "",
      BuildingSqft: "",
      Rooms: "",
      Bedrooms: "",
      Bathrooms: "",
      Pool: "",
      SiteAddressUnitNumber: "",
      NumberofStories: "",
      NumberofUnits: "",
      SalesPrice: "",
      SalesPriceCode: "",
      SaleDate: "",
      SalesDocumentNumber: "",
      AssessedLandValue: "",
      AssessedImprovePercent: "",
      AssessedImprovementValue: "",
      EstValue: "",
      EstEquity: "",
      ListedforSale: "",
      PrimaryPhone1: "",
      PrimaryMobilePhone1: "",
      PrimaryEmail1: "",
      PrimaryPhone1Hash: "",
      PrimaryEmail1Hash: "",
      SecondaryPhone1: "",
      SecondaryMobilePhone1: "",
      SecondaryPhone1Hash: "",
      SecondaryEmail1: "",
      SecondaryEmail1Hash: "",
      LotAreaAcres: "",
      LotAreaSQFT: "",
      ParcelNumber: "",
      YearBuilt: "",
      GarageNumberofCars: "",
      GarageType: "",
      Tract: "",
      TaxExemptionCode: "",
      TaxDelinquent: "",
      TaxDelinquentYears: "",
      TaxYear: "",
      View: "",
      CostPerSqFt: "",
      DeedType: "",
      TaxArea: "",
      TaxAmount: "",
      LoanAmount: "",
      LoanAmount2nd: "",
      LoanType: "",
      LenderName: "",
      TitleCompanyName: "",
      PriorSaleDate: "",
      PriorSalesPrice: "",
      Latitude: "",
      Longitude: "",
      SellerAgent: "",
      SellerAgentCompany: "",
      BuyerAgent: "",
      BuyerAgentCompany: "",
      CensusTract: "",
      file_name: "",
    });

    const tableData = ref({
      data: [],
      meta: {
        total: 0,
      },
    });
    const loading = ref(true);

    onMounted(async () => {
      setCurrentPageTitle("Real Estate Search");

      loading.value = true;

      const keys = Object.keys(route.query);
      if (keys.length > 0) {
        searchParam.value[keys[0]] = route.query[keys[0]];
      }

      setTimeout(async () => {
        tableData.value = await getHomes(pagination.value, sort.value);
        loading.value = false;
        const res = await ApiService.get(`dev/realestate?limit=100`);
        realEstate.value = res.data.data[0];
      }, 1000);
    });

    const search = async () => {
      loading.value = true;
      tableData.value = await getHomes(pagination.value, sort.value);
      loading.value = false;
    };

    const getHomes = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "&sort=id,desc";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }
        let url = `dev/realestate?offset=${offset}&limit=${rowsPerPage}${sortParam}`;
        if (searchParam.value.search !== "") {
          url = `${url}&search[]=${searchParam.value.search}`;
        }
        if (searchParam.value.id !== "") {
          url = `${url}&id=${searchParam.value.id}`;
        }
        if (searchParam.value.FullSiteAddress !== "") {
          url = `${url}&FullSiteAddress=${searchParam.value.FullSiteAddress}`;
        }
        if (searchParam.value.SiteAddressStreetPrefix !== "") {
          url = `${url}&SiteAddressStreetPrefix=${searchParam.value.SiteAddressStreetPrefix}`;
        }
        if (searchParam.value.file_name !== "") {
          url = `${url}&file_name=${searchParam.value.file_name}`;
        }
        if (searchParam.value.SiteAddressStreetName !== "") {
          url = `${url}&SiteAddressStreetName=${searchParam.value.SiteAddressStreetName}`;
        }
        if (searchParam.value.SiteAddressCity !== "") {
          url = `${url}&SiteAddressCity=${searchParam.value.SiteAddressCity}`;
        }
        if (searchParam.value.SiteAddressState !== "") {
          url = `${url}&SiteAddressState=${searchParam.value.SiteAddressState}`;
        }
        if (searchParam.value.SiteAddressUnitNumber !== "") {
          url = `${url}&SiteAddressUnitNumber=${searchParam.value.SiteAddressUnitNumber}`;
        }
        if (searchParam.value.SiteAddressZip !== "") {
          url = `${url}&SiteAddressZip=${searchParam.value.SiteAddressZip}`;
        }
        if (searchParam.value.SiteCarrierRoute !== "") {
          url = `${url}&SiteCarrierRoute=${searchParam.value.SiteCarrierRoute}`;
        }
        if (searchParam.value.Owner1FirstName !== "") {
          url = `${url}&Owner1FirstName=${searchParam.value.Owner1FirstName}`;
        }
        if (searchParam.value.Owner1MiddleName !== "") {
          url = `${url}&Owner1MiddleName=${searchParam.value.Owner1MiddleName}`;
        }
        if (searchParam.value.Owner1LastName !== "") {
          url = `${url}&Owner1LastName=${searchParam.value.Owner1LastName}`;
        }
        if (searchParam.value.Owner1SpouseFirstName !== "") {
          url = `${url}&Owner1SpouseFirstName=${searchParam.value.Owner1SpouseFirstName}`;
        }
        if (searchParam.value.Owner2FirstName !== "") {
          url = `${url}&Owner2FirstName=${searchParam.value.Owner2FirstName}`;
        }
        if (searchParam.value.Owner2MiddleName !== "") {
          url = `${url}&Owner2MiddleName=${searchParam.value.Owner2MiddleName}`;
        }
        if (searchParam.value.Owner2LastName !== "") {
          url = `${url}&Owner2LastName=${searchParam.value.Owner2LastName}`;
        }
        if (searchParam.value.Owner2SpouseFirstName !== "") {
          url = `${url}&Owner2SpouseFirstName=${searchParam.value.Owner2SpouseFirstName}`;
        }
        if (searchParam.value.MailAdressStreetNumber !== "") {
          url = `${url}&MailAdressStreetNumber=${searchParam.value.MailAdressStreetNumber}`;
        }
        if (searchParam.value.MailAddressStreetPrefix !== "") {
          url = `${url}&MailAddressStreetPrefix=${searchParam.value.MailAddressStreetPrefix}`;
        }
        if (searchParam.value.MailAddressStreetName !== "") {
          url = `${url}&MailAddressStreetName=${searchParam.value.MailAddressStreetName}`;
        }
        if (searchParam.value.MailAddressUnitNumber !== "") {
          url = `${url}&MailAddressUnitNumber=${searchParam.value.MailAddressUnitNumber}`;
        }
        if (searchParam.value.MailAddressCity !== "") {
          url = `${url}&MailAddressCity=${searchParam.value.MailAddressCity}`;
        }
        if (searchParam.value.MailAddressState !== "") {
          url = `${url}&MailAddressState=${searchParam.value.MailAddressState}`;
        }
        if (searchParam.value.MailAddressZip !== "") {
          url = `${url}&MailAddressZip=${searchParam.value.MailAddressZip}`;
        }
        if (searchParam.value.MailAddressStreetName !== "") {
          url = `${url}&MailAddressStreetName=${searchParam.value.MailAddressStreetName}`;
        }
        if (searchParam.value.MailCarrierRoute !== "") {
          url = `${url}&MailCarrierRoute=${searchParam.value.MailCarrierRoute}`;
        }
        if (searchParam.value.OwnerOccupied !== "") {
          url = `${url}&OwnerOccupied=${searchParam.value.OwnerOccupied}`;
        }
        if (searchParam.value.UseCodeDescription !== "") {
          url = `${url}&UseCodeDescription=${searchParam.value.UseCodeDescription}`;
        }
        if (searchParam.value.UseCodeCounty !== "") {
          url = `${url}&UseCodeCounty=${searchParam.value.UseCodeCounty}`;
        }
        if (searchParam.value.BuildingSqft !== "") {
          url = `${url}&BuildingSqft=${searchParam.value.BuildingSqft}`;
        }
        if (searchParam.value.Rooms !== "") {
          url = `${url}&Rooms=${searchParam.value.Rooms}`;
        }
        if (searchParam.value.Bedrooms !== "") {
          url = `${url}&Bedrooms=${searchParam.value.Bedrooms}`;
        }
        if (searchParam.value.Bathrooms !== "") {
          url = `${url}&Bathrooms=${searchParam.value.Bathrooms}`;
        }
        if (searchParam.value.Pool !== "") {
          url = `${url}&Pool=${searchParam.value.Pool}`;
        }
        if (searchParam.value.NumberofStories !== "") {
          url = `${url}&NumberofStories=${searchParam.value.NumberofStories}`;
        }
        if (searchParam.value.NumberofUnits !== "") {
          url = `${url}&NumberofUnits=${searchParam.value.NumberofUnits}`;
        }
        if (searchParam.value.SalesPrice !== "") {
          url = `${url}&SalesPrice=${searchParam.value.SalesPrice}`;
        }
        if (searchParam.value.SalesPriceCode !== "") {
          url = `${url}&SalesPriceCode=${searchParam.value.SalesPriceCode}`;
        }
        if (searchParam.value.SaleDate !== "") {
          url = `${url}&SaleDate=${searchParam.value.SaleDate}`;
        }
        if (searchParam.value.NumberofStories !== "") {
          url = `${url}&SalesDocumentNumber=${searchParam.value.SalesDocumentNumber}`;
        }
        if (searchParam.value.AssessedLandValue !== "") {
          url = `${url}&AssessedLandValue=${searchParam.value.AssessedLandValue}`;
        }
        if (searchParam.value.AssessedImprovementValue !== "") {
          url = `${url}&AssessedImprovementValue=${searchParam.value.AssessedImprovementValue}`;
        }
        if (searchParam.value.EstValue !== "") {
          url = `${url}&EstValue=${searchParam.value.EstValue}`;
        }
        if (searchParam.value.EstEquity !== "") {
          url = `${url}&EstEquity=${searchParam.value.EstEquity}`;
        }
        if (searchParam.value.ListedforSale !== "") {
          url = `${url}&ListedforSale=${searchParam.value.ListedforSale}`;
        }
        if (searchParam.value.PrimaryPhone1 !== "") {
          url = `${url}&PrimaryPhone1=${searchParam.value.PrimaryPhone1}`;
        }
        if (searchParam.value.PrimaryMobilePhone1 !== "") {
          url = `${url}&PrimaryMobilePhone1=${searchParam.value.PrimaryMobilePhone1}`;
        }
        if (searchParam.value.PrimaryEmail1 !== "") {
          url = `${url}&PrimaryEmail1=${searchParam.value.PrimaryEmail1}`;
        }
        if (searchParam.value.PrimaryPhone1Hash !== "") {
          url = `${url}&PrimaryPhone1Hash=${searchParam.value.PrimaryPhone1Hash}`;
        }
        if (searchParam.value.PrimaryEmail1Hash !== "") {
          url = `${url}&PrimaryEmail1Hash=${searchParam.value.PrimaryEmail1Hash}`;
        }
        if (searchParam.value.SecondaryPhone1 !== "") {
          url = `${url}&SecondaryPhone1=${searchParam.value.SecondaryPhone1}`;
        }
        if (searchParam.value.SecondaryPhone1Hash !== "") {
          url = `${url}&SecondaryPhone1Hash=${searchParam.value.SecondaryPhone1Hash}`;
        }
        if (searchParam.value.SecondaryEmail1 !== "") {
          url = `${url}&SecondaryEmail1=${searchParam.value.SecondaryEmail1}`;
        }
        if (searchParam.value.SecondaryEmail1Hash !== "") {
          url = `${url}&SecondaryEmail1Hash=${searchParam.value.SecondaryEmail1Hash}`;
        }
        if (searchParam.value.LotAreaAcres !== "") {
          url = `${url}&LotAreaAcres=${searchParam.value.LotAreaAcres}`;
        }
        if (searchParam.value.LotAreaSQFT !== "") {
          url = `${url}&LotAreaSQFT=${searchParam.value.LotAreaSQFT}`;
        }
        if (searchParam.value.ParcelNumber !== "") {
          url = `${url}&ParcelNumber=${searchParam.value.ParcelNumber}`;
        }
        if (searchParam.value.YearBuilt !== "") {
          url = `${url}&YearBuilt=${searchParam.value.YearBuilt}`;
        }
        if (searchParam.value.GarageNumberofCars !== "") {
          url = `${url}&GarageNumberofCars=${searchParam.value.GarageNumberofCars}`;
        }
        if (searchParam.value.GarageType !== "") {
          url = `${url}&SalesDocumentNumber=${searchParam.value.GarageType}`;
        }
        if (searchParam.value.Tract !== "") {
          url = `${url}&Tract=${searchParam.value.Tract}`;
        }
        if (searchParam.value.TaxExemptionCode !== "") {
          url = `${url}&TaxExemptionCode=${searchParam.value.TaxExemptionCode}`;
        }
        if (searchParam.value.TaxDelinquent !== "") {
          url = `${url}&TaxDelinquent=${searchParam.value.TaxDelinquent}`;
        }

        if (searchParam.value.TaxYear !== "") {
          url = `${url}&TaxYear=${searchParam.value.TaxYear}`;
        }
        if (searchParam.value.View !== "") {
          url = `${url}&View=${searchParam.value.View}`;
        }
        if (searchParam.value.CostPerSqFt !== "") {
          url = `${url}&CostPerSqFt=${searchParam.value.CostPerSqFt}`;
        }
        if (searchParam.value.DeedType !== "") {
          url = `${url}&DeedType=${searchParam.value.DeedType}`;
        }
        if (searchParam.value.TaxArea !== "") {
          url = `${url}&TaxArea=${searchParam.value.TaxArea}`;
        }
        if (searchParam.value.TaxAmount !== "") {
          url = `${url}&TaxAmount=${searchParam.value.TaxAmount}`;
        }
        if (searchParam.value.LoanAmount !== "") {
          url = `${url}&LoanAmount=${searchParam.value.LoanAmount}`;
        }
        if (searchParam.value.TaxYear !== "") {
          url = `${url}&TaxYear=${searchParam.value.TaxYear}`;
        }
        if (searchParam.value.LoanAmount2nd !== "") {
          url = `${url}&LoanAmount2nd=${searchParam.value.LoanAmount2nd}`;
        }
        if (searchParam.value.LoanType !== "") {
          url = `${url}&LoanType=${searchParam.value.LoanType}`;
        }
        if (searchParam.value.LenderName !== "") {
          url = `${url}&LenderName=${searchParam.value.LenderName}`;
        }
        if (searchParam.value.TitleCompanyName !== "") {
          url = `${url}&TitleCompanyName=${searchParam.value.TitleCompanyName}`;
        }
        if (searchParam.value.PriorSaleDate !== "") {
          url = `${url}&PriorSaleDate=${searchParam.value.PriorSaleDate}`;
        }
        if (searchParam.value.PriorSalesPrice !== "") {
          url = `${url}&PriorSalesPrice=${searchParam.value.PriorSalesPrice}`;
        }
        if (searchParam.value.Latitude !== "") {
          url = `${url}&Latitude=${searchParam.value.Latitude}`;
        }
        if (searchParam.value.Longitude !== "") {
          url = `${url}&Longitude=${searchParam.value.Longitude}`;
        }
        if (searchParam.value.SellerAgent !== "") {
          url = `${url}&SellerAgent=${searchParam.value.SellerAgent}`;
        }
        if (searchParam.value.SellerAgentCompany !== "") {
          url = `${url}&SellerAgentCompany=${searchParam.value.SellerAgentCompany}`;
        }
        if (searchParam.value.BuyerAgent !== "") {
          url = `${url}&BuyerAgent=${searchParam.value.BuyerAgent}`;
        }
        if (searchParam.value.BuyerAgentCompany !== "") {
          url = `${url}&BuyerAgentCompany=${searchParam.value.BuyerAgentCompany}`;
        }
        if (searchParam.value.CensusTract !== "") {
          url = `${url}&CensusTract=${searchParam.value.CensusTract}`;
        }

        const { data } = await ApiService.get(url);
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };

    const getTotal = computed(() => {
      if (tableData.value.meta && tableData.value.meta.total) {
        return tableData.value.meta.total;
      }

      return 0;
    });

    const pagination = ref({
      page: 1,
      total: getTotal.value,
      rowsPerPage: 25,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });
    const checkedHomes = ref([]);
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
      },
      {
        name: "ID",
        key: "id",
        sortable: true,
      },
      {
        name: "Address",
        key: "FullSiteAddress",
        sortable: true,
      },
      {
        name: "HouseNumber",
        key: "SiteAddressHouseNumber",
        sortable: true,
      },
      {
        name: "StreetName",
        key: "SiteAddressStreetName",
        sortable: true,
      },
      {
        name: "City",
        key: "SiteAddressCity",
        sortable: true,
      },
      {
        name: "State",
        key: "SiteAddressState",
        sortable: true,
      },
    ]);

    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      tableData.value = await getHomes(pagination.value, sort.value);
      loading.value = false;
    };

    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      tableData.value = await getHomes(pagination.value, sort.value);
      loading.value = false;
    };

    const onItemsPerPageChange = async (val) => {
      pagination.value.rowsPerPage = val;

      loading.value = true;
      tableData.value = await getHomes(pagination.value, sort.value);
      loading.value = false;
    };

    const deleteCustomer = (id) => {
      console.log(id);
    };

    const exportButton = ref<HTMLButtonElement | null>(null);

    const exportCsv = async () => {
      // eslint-disable-next-line
      exportButton.value!.disabled = true;

      // Activate indicator
      exportButton.value?.setAttribute("data-kt-indicator", "on");

      let worksheet, fileName;
      const csvData = await getHomes(
        { page: 1, rowsPerPage: tableData.value.meta.total },
        sort.value
      );
      worksheet = XLSX.utils.json_to_sheet(csvData.data);
      fileName =
        "RealEstate_export_" +
        moment().format("YYYYMMDD_hhmmss").toString() +
        ".csv";

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, worksheet);
      XLSX.writeFile(wb, fileName);

      exportButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      exportButton.value!.disabled = false;
    };

    return {
      searchParam,
      tableData,
      tableHeader,
      loading,
      checkedHomes,
      pagination,
      realEstate,
      onCurrentChange,
      onSort,
      onItemsPerPageChange,
      deleteCustomer,
      search,
      getTotal,
      exportCsv,
      exportButton,
    };
  },
});
